export default class LikeWidget {

  constructor(element, options = {}) {
    this.node = element;
    this.postID = this.node.getAttribute('data-post-id');
    this.data;

    console.log(this.node);

    this.loadData();

    this.vote_clicked = false;

    if (this.node) {
      this.init();
    }
  }

  async loadData() {
    try {
      const response = await fetch(`/userdata/local/post-likes/post_${this.postID}.json`);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      this.data = await response.json();
      console.log(this.data);

      this.node.querySelector('[data-votes-up]').innerHTML = this.data.up ?? 0;
    } catch (error) {
      console.error(error);
      this.node.textContent = 'Failed to load data.';
    }
  }

  init() {

    // add votes bar
    // this.updateVotesBar();

    this.node.querySelector('[data-vote-up]').addEventListener('click', (e) => {
      console.log('voting');
      e.preventDefault();
      this.save({
        post_id: this.postID,
        vote_up: 1
      });

      this.vote_clicked = true;
    });

    /*
    this.node.querySelector('[data-vote-down]').addEventListener('click', (e) => {
        e.preventDefault();
        this.save({
            post_id: this.postID,
            vote_down: 1
        });

        this.vote_clicked = true;
    });
    */
  }


  updateVotesBar() {

    let up = parseInt(this.data.up);
    let down = parseInt(this.data.down);
    let percent = 50;

    if (up !== down) {
      let sum = up + down;
      percent = up / sum * 100;
    }

    let $vbar = this.node.querySelector('[data-votes-bar]');

    if ($vbar) {
      let $voteBar = $vbar.querySelector('.votes-bar');

      if ($voteBar && $voteBar.length) {
        $voteBar.style.width = percent + '%';
      } else {
        let $bar = document.createElement('span');
        $bar.setAttribute('class', 'votes-bar');
        $bar.style.width = percent + '%';
        this.node.querySelector('[data-votes-bar]').appendChild($bar);
        this.node.querySelector('.votes-bar').style.width = percent + '%';
      }
    }

  }


  save(obj) {

    if (this.vote_clicked) {
      return;
    }

    let data = Object.assign({}, {
      action: 'post_vote'
    }, obj);


    this.app.Ajax.load(this.url, data, (response) => {
      if (response && response.hasOwnProperty('vote_up')) {
        let element = this.node.querySelector('[data-votes-up]');
        if (element) {
          element.innerText = response.votes;
          this.param.up = response.votes;
        }
      }

      if (response && response.hasOwnProperty('vote_down')) {
        let element = this.node.querySelector('[data-votes-down]');
        if (element) {
          element.innerText = response.votes;
          this.param.up = response.votes;
        }
      }

      this.updateVotesBar();
    }, 'POST');

  }

}
